import { NgModule } from '@angular/core';
import { PLabelValueComponent } from './p-label-value.component';

@NgModule({
    declarations: [PLabelValueComponent],
    imports: [],
    exports: [PLabelValueComponent]
})
export class PLabelValueModule {}
